<template>
  <div :class="NavBarClass" id="myTopnav">
    <User_ChangePass v-model="ShowChangePassword" />
    <a
      href="javascript:void(0);"
      style="background-color: green"
      class="icon"
      @click="myFunction"
    >
      <i class="fa fa-bars"></i>
    </a>

    <a id="plsLogo">
      <img style="width: 25px; height: 25px" src="../assets/plslogo.png" />
      PLS SYSTEM
    </a>

    <router-link class="routeLink" to="/">
      {{ IsManager ? "MANAGER" : "DASHBOARD" }}
    </router-link>

    <router-link v-if="IsManager" class="routeLink" to="/dashboard">
      DASHBOARD
    </router-link>
    <router-link v-if="IsManager || IsGuest" class="routeLink" to="/checkcode">
      CHECK CODE
    </router-link>

    <router-link v-if="IsManager || IsGuest" class="routeLink" to="/checkphone">
      CHECK SĐT
    </router-link>

    <router-link v-if="IsManager || IsGuest" class="routeLink" to="/blocklist">
      BLOCK LIST
    </router-link>
    <router-link
      v-if="IsManager || IsAccountant"
      class="routeLink"
      to="/report"
    >
      REPORT
    </router-link>
    <router-link v-if="IsManager" class="routeLink" to="/voucherimport">
      IMPORT VOUCHER
    </router-link>

    <a class="LastChild">
      <a class="lblName"> {{ TIME }} | Xin chào </a>

      <a class="lblDivine" style="padding: 0px 10px">
        <hr />
      </a>

      <a-dropdown>
        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
          {{ UserDisplayName }}
          <a-icon type="down" />
        </a>

        <a-menu slot="overlay">
          <a-menu-item>
            <p @click="ShowChangePassword = true">
              <i class="fa fa-user-circle-o" aria-hidden="true"></i>
              Đổi mật khẩu
            </p>
            <!-- <router-link to="/userinfo">
              <i
                class="fa fa-user-circle-o"
                aria-hidden="true"
              ></i>
              Đổi mật khẩu
            </router-link> -->
          </a-menu-item>

          <!-- <a-menu-item>
            <router-link to="/userhistory">
              <i
                class="fa fa-history"
                aria-hidden="true"
              ></i>
              Lịch sử tương tác
            </router-link>
          </a-menu-item> -->

          <a-menu-item>
            <p @click="API_Logout()">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              Đăng xuất
            </p>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import User_ChangePass from "@/components/User_ChangePass.vue";

export default {
  name: "Navbar",

  components: {
    User_ChangePass,
  },
  computed: {
    ...mapState([
      "isLogin",
      "oUser"
    ]),

        IsAccountant() {
            return this.oUser.Role.includes(
                "ACCOUNTANT"
            );
        },
        IsManager() {
        return !!(
          this.oUser &&
          this.oUser.Role &&
          this.oUser.Role.includes("MANAGER")
        );
      },
        IsGuest() {
            return this.oUser.Role.includes(
                "GUEST"
            );
        },
    UserDisplayName() {
      if (!this.oUser) {
        return "";
      }

      return (
        this.oUser.Name ||
        this.oUser.Full_Name ||
        this.oUser.Username ||
        this.oUser.Usermame ||
        ""
      );
    }
  },

  data() {
    return {
      TIME: "",
      NavBarClass: "topnav",
      ShowChangePassword: false,
    };
  },

  methods: {
    ...mapActions([
      "API_Logout",
      "Go_Route"
    ]),

    UserInfo() {
      this.Go_Route(
        "/UserInfo"
      );
    },

    myFunction() {
      if (
        this.NavBarClass ===
        "topnav"
      ) {
        this.NavBarClass +=
          " responsive";
      } else {
        this.NavBarClass =
          "topnav";
      }
    }
  },

  mounted() {
    try {
      axios
        .get(
          this.$PRJ_DOMAIN +
          "/api/getnowtime"
        )
        .then((res) => {
          const payload =
            res &&
            res.data !== undefined
              ? res.data
              : res;

          if (
            payload &&
            payload.State == 1
          ) {
            this.TIME =
              moment(
                payload.Message
              ).format(
                "DD/MM/YYYY HH:mm:ss"
              );
          } else {
            this.TIME =
              moment().format(
                "DD/MM/YYYY HH:mm:ss"
              );
          }
        })
        .catch(() => {
          this.TIME =
            moment().format(
              "DD/MM/YYYY HH:mm:ss"
            );
        });
    } catch (error) {
      this.TIME =
        moment().format(
          "DD/MM/YYYY HH:mm:ss"
        );
    }
  }
};
</script>

<style scoped>
.fish.menu.vertical > .item {
  border: 1px solid #cccccc;
}

.topnav {
  background-color: #e0f0fa;
  overflow: hidden;
}

.LastChild {
  padding: 0px !important;
  float: right !important;
}

#plsLogo {
  pointer-events: none;
  text-align: unset !important;
  display: block;
  height: 39.5px;
  padding: 7px !important;
  color: white;
  background-color: #0f609a;
  border-right: 1px solid;
  font-weight: bold;
  font-size: 16px !important;
  width: 150px;
}

.topnav a {
  float: left;
  display: block;
  text-align: center;
  padding: 10px 14px;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
  color: #2c3e50;
}

.topnav a.routeLink:hover {
  background-color: green;
  color: white !important;
}

.topnav a.router-link-exact-active {
  background-color: green;
  color: white;
}

.topnav .icon {
  width: 40px;
  height: 39.5px;
  display: none;
}

@media screen and (max-width: 600px) {
  .topnav .LastChild {
    float: unset !important;
  }

  .topnav a#plsLogo {
    border-right: unset;
    width: calc(100% - 40px);
  }

  .topnav a:not(:first-child) {
    display: none;
  }

  .topnav a.icon {
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .topnav.responsive .lblName {
    display: none;
  }

  .topnav.responsive a#plsLogo {
    border-right: unset;
    width: calc(100% - 40px);
    margin-left: 40px;
  }

  .topnav.responsive {
    position: relative;
  }

  .topnav.responsive a.icon {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
  }

  .topnav.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
}
</style>
